import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { COLORS } from '../utils/colors';

interface NavigationBarProps {
  onBackOpen: ()=>void,
  onStatsOpen: ()=>void,
  onHelpOpen: ()=>void,
  completed: boolean,
  elapsedTime: string,
  helpIcon: any,
  igIcon: any,
  statsIcon: any,
  backIcon: any,
}

function NavigationBar(props: NavigationBarProps) {

  function getFontColor() {
    return props.completed ? COLORS.GREEN : COLORS.BLACK;
  }

  return (
    <Navbar
      style={{
        marginBottom: 40,
        height: 40,
        paddingLeft: window.outerWidth < 768 ? 2 : '25%',
        paddingRight: window.outerWidth < 768 ? 2 : '25%',
      }}
      className="bg-body-secondary"
    >
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Container className="d-flex justify-content-start">
          <img
            src={props.backIcon}
            style={{ cursor: 'pointer' }}
            onClick={() => props.onBackOpen()}
            className='icon'
            alt="back"
          />
        </Container>
        <div className="elapsed-time-container" style={{ color: getFontColor() }}>
          {props.elapsedTime}
        </div>
        <Container className="d-flex justify-content-end">
          {props.completed && (
            <img
              src={props.statsIcon}
              style={{ cursor: 'pointer' }}
              onClick={() => props.onStatsOpen()}
              className='icon'
              alt="stats"
            />
          )}
          <img
            src={props.helpIcon}
            style={{ cursor: 'pointer' }}
            onClick={() => props.onHelpOpen()}
            className='icon'
            alt="help"
          />
          <a href="https://instagram.com/puzzli_game" target="_blank" rel="noopener noreferrer">
            <img
              src={props.igIcon}
              style={{ cursor: 'pointer' }}
              className='icon'
              alt="instagram"
            />
          </a>
        </Container>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
